import { useToast } from '@melio/penny';
import { PlaidAccountData, useFundingSources } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

import { AddPlaidFundingSourceScreen } from './screens';

export type AddPlaidFundingSourceActivityProps = {
  onError?: ErrorFunction;
  onDone: (id: string) => unknown;
  onClose?: VoidFunction;
  billId?: string;
};

export const AddPlaidFundingSourceActivity = forwardRef<AddPlaidFundingSourceActivityProps, 'iframe'>(
  ({ onDone, onClose, onError, billId, ...props }, ref) => {
    const toast = useToast();
    const errorHandler: ErrorFunction = (error) => {
      toast({ type: 'error', title: error.message });
      onError?.(error);
      onClose?.();
    };

    const { create } = useFundingSources({ enabled: false });

    const createPlaidFundingSource = (data: PlaidAccountData) => {
      create({
        type: 'plaid',
        details: { plaidAccountId: data.accounts[0]?.id as string, plaidToken: data.public_token },
      })
        .then(({ id }) => onDone(id))
        .catch(onError);
    };

    return (
      <AddPlaidFundingSourceScreen
        data-component={AddPlaidFundingSourceActivity.displayName}
        onSuccess={createPlaidFundingSource}
        onClose={onClose}
        onError={errorHandler}
        {...props}
        ref={ref}
      />
    );
  }
);
AddPlaidFundingSourceActivity.displayName = 'AddPlaidFundingSourceActivity';
